import useSessionStorage from './useSessionStorage';
/**
 * gets and sets the vip account data from cache.
 * use the loadvipaccount component to fetch.
 */
function useVipAccountCache() {
  const [vipAccount, setVipAccount] = useSessionStorage('vip-account');
  return {vipAccount, setVipAccount};
}
export default useVipAccountCache;
